import React, { useMemo, useRef } from "react";
import Select from "../../../UI/Form/Select/Select";
import { getSingleFiscalQuarters } from "../../../utils/formatters/dateFormatter";
import useToDateFiltersLocalState from "./useToDateFiltersLocalState";

export default React.memo(function QuarterRange(props) {
  const {
    dateFiltersConfig,
    getPosition,
    RecentPeriods,
    recentMonthsChange,
    getUserSelectedDateOption,
    activeTabUuid,
    selectedDateType,
    saveStickyDatesToStore,
    dateConfig,
    recentSelectedDatePreset,
  } = props;

  const ref = useRef();

  const options = useMemo(
    () => getSingleFiscalQuarters(dateFiltersConfig),
    [dateFiltersConfig]
  );

  // site config default quarter
  const quarter = dateFiltersConfig.defaultFiscalQuarter;
  // default quarter option
  const option = options.find((option) => option.label === quarter) ?? {};

  const { localState, setLocalState } = useToDateFiltersLocalState(
    dateConfig.tabChanged,
    option
  );

  const userSavedOption = getUserSelectedDateOption(
    dateFiltersConfig,
    activeTabUuid
  ) ?? {
    ...localState,
    ...(recentSelectedDatePreset ?? {}),
  };

  const { from, to } = userSavedOption;

  function getValue(key) {
    return options.find((option) => option[key] === userSavedOption[key]);
  }

  // not show options which greater then end date
  const endIndex = options.findIndex((option) => option.to === to);
  const startOptions = options.filter((_, index) => index <= endIndex);

  // not show options which less then start date
  const startIndex = options.findIndex((option) => option.from === from);
  const endOptions = options.filter((_, index) => index >= startIndex);

  return (
    <RecentPeriods ref={ref}>
      <Select
        options={startOptions}
        onChange={(option) => {
          recentMonthsChange({ from: option.from, to });
          saveStickyDatesToStore(selectedDateType, { ...option, to });
          setLocalState({ ...option, to });
        }}
        getOptionValue={(o) => o.from}
        placeholder="From"
        value={getValue("from")}
        menuPlacement={getPosition(ref)}
      />
      <br />
      <Select
        options={endOptions}
        onChange={(option) => {
          recentMonthsChange({ from, to: option.to });
          saveStickyDatesToStore(selectedDateType, { ...option, from });
          setLocalState({ ...option, from });
        }}
        getOptionValue={(o) => o.from}
        placeholder="To"
        value={getValue("to")}
        menuPlacement={getPosition(ref)}
      />
    </RecentPeriods>
  );
});
